import { FinalCalculation } from './FinalCalculation';
import { Product } from './Product';
import { Reference } from './Reference';

export class HrMaxPrice {
	public constructor(
		public readonly reference: Reference,
		public readonly products: Product[],
		public readonly finalCalculation: FinalCalculation,
		public readonly links: { [key: string]: string }
	) {}

	public getExportXlsLink(): string {
		return this.links['export-xls'];
	}
}
